import jsonapi from 'jsonapi-parse';

export default $axios => () => ({
    async get(file) {
        let response = await $axios.$get(`/api/v1/consistency-check/${file}`);
        return jsonapi.parse(response).data;
    },
});
